<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import ContactForm from "@/contacts/ContactForm.vue";
import { useGetContact, useUpdateContact } from "@/contacts/contactsCrud";
import ViewHeader from "./ViewHeader.vue";

const { contactId } = defineProps<{ contactId: string }>();

const { contact, getContactStatus } = useGetContact(contactId);
const { updateContact, updateContactStatus } = useUpdateContact();
</script>

<template>
  <HandleQueryStatus :query-status="getContactStatus">
    <template v-if="contact !== undefined">
      <ViewHeader
        :redirect-on-close-target="{
          name: 'canvassFlowHouseContacts',
        }"
      >
        {{ contact.name }}
        <template v-if="contact.address.street !== null" #subheading
          >Adresse: {{ contact.address.street }}
          {{ contact.address.houseNumber }}</template
        >
      </ViewHeader>
      <div class="container container-lg">
        <ContactForm
          :contact-details="contact"
          :update-contact-status="updateContactStatus"
          @update="updateContact"
        />
      </div>
    </template>
  </HandleQueryStatus>
</template>
